$(function(){
    $('#forget_pw').on('click', function() {
        $('.login_box').hide();
        $('.pw_reset_box').show();
    });
    $('#forget_pw_cancel').on('click', function() {
        $('.login_box').show(); 
        $('.pw_reset_box').hide();
    });

  
  // スムーズスクロール
  $('a[href^="#"]').click(function() {
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
  });

  
  //スマホのみ電話リンクを付与
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
    $(".tel_link").each(function () {
      var tel = $(this);
      var html = tel.html();
      var teltext = tel.text();
      var telnum = teltext.replace(/[^0-9]/g, "");
      tel.html(
        $("<a>")
          .attr("href", "tel:" + telnum)
          .append(html)
      );
    });
  }

  //サイドバーアコーディオン
  $('.ac_btn').click(function() {
    $(this).toggleClass("open");
    $(this).nextAll('.child_list').slideToggle();
  });

  // ハンバーガーメニューOPEN
  $('.nav_btn').on('click',function(){
    var rightVal = 0;
    if($(this).hasClass('nav_open')){
      rightVal = '-100%';
      $(this).removeClass('nav_open');
      $('.header').removeClass('fixed');
    }else{
      $(this).addClass('nav_open');
      $('.header').addClass('fixed');
    }

    $('#js_nav_content').stop().animate({
      right: rightVal
    }, 300);
  });

  // ヘッダーナビゲーション アコーディオンメニュー
  $('.nav_ac_btn').click(function() {
    $(this).toggleClass("open");
    $(this).nextAll('.ac_content').slideToggle();
  });


  // マイページ 住所編集
  $('button[id^="EditFormButton_"]').click(function() {
    var addressId = $(this).data('address-id');
    var $editDiv = $('#EditAddress_' + addressId);
    
    if ($editDiv.css('display') === 'none') {
      $editDiv.css('display', 'block');
    } else {
      $editDiv.css('display', 'none');
    }
  });
  $('.edit_reset_btn').click(function() {
    var $editDiv = $(this).closest('.edit_form');
    $editDiv.css('display', 'none');
  });
});
